import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchInputProps {
  defaultValue?: string;
  placeholder?: string;
  onSearch?: (keyword: string) => void;
  autoFocus?: boolean;
  className?: string;
}

export default function SearchInput({
  defaultValue = '',
  placeholder = '搜索视频标题或简介…',
  onSearch,
  autoFocus = false,
  className = '',
}: SearchInputProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const keyword = value.trim();
    if (onSearch) {
      onSearch(keyword);
      return;
    }
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
  };

  return (
    <form onSubmit={handleSubmit} className={`relative flex items-center ${className}`}>
      <span className="pointer-events-none absolute left-3 flex h-5 w-5 items-center justify-center text-foreground-400">
        <i className="ri-search-line text-base" />
      </span>
      <input
        type="search"
        value={value}
        autoFocus={autoFocus}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        aria-label="搜索视频"
        className="h-10 w-full rounded-full border border-background-300/70 bg-background-100 pl-10 pr-24 text-sm text-foreground-800 placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50 focus:outline-none focus:ring-2 focus:ring-primary-100"
      />
      <button
        type="submit"
        className="absolute right-1.5 h-7 whitespace-nowrap rounded-full bg-primary-500 px-4 text-xs font-semibold text-background-50 transition-colors hover:bg-primary-600"
      >
        搜索
      </button>
    </form>
  );
}